import React, { useEffect, useState } from "react";
import order from "../../../images/Icons/product-icon.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchSentOrder } from "../../../redux/slice/sentOrder";
import config from "../../../config";
import placeImage from "../../../images/placeholder.jpg";
import { fetchReceivedOrder } from "../../../redux/slice/receivedOrder";
import useLogout from "../../Auth/useLogout";
import NoData from "../../../Component/NoData";
import Dataloader from "../../../Component/Dataloader";
import { hasPermission, canAccessRoute } from "../../../utils/permissionUtils";
import { toast } from "react-toastify";


export default function OrderBook() {
  const navigate = useNavigate();
  const user = config.user;
  const dispatch = useDispatch();
  const logout = useLogout();
  
  // Check if user has permission to access this page
  useEffect(() => {
    if (!canAccessRoute('order-book')) {
      navigate('/');
      toast.error('You do not have permission to access this page', {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }, [navigate]);
  
  const { sentOrderData, isError1 } = useSelector((state) => state.sentOrder);
  const { receivedOrderData, isError2 } = useSelector(
    (state) => state.receivedOrder
  );
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      if (!isError1 && !isError2) {
        setLoading(true);
        try {
          await dispatch(fetchSentOrder(logout));
          await dispatch(fetchReceivedOrder(logout));
        } catch (error) {
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch, isError1, isError2, logout]);

  const [filter, setFilter] = useState(
    user && (user.type === "seller" ? "received" : "sent")
  );
  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };
  const getFilteredData = () => {
    switch (filter) {
      case "received":
        return receivedOrderData.map((item) => ({ ...item, type: "received" }));

      default:
        return sentOrderData.map((item) => ({ ...item, type: "sent" }));
    }
  };
  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                <div className="row-hd-txt">
                  <div className="row-hd-txt-left">
                    <img src={order} alt="" />
                    <h5>All Orders</h5>
                  </div>
                  <div className="order-txt-right">
                    {user && user.type === "seller" && (
                      <select onChange={handleFilterChange}>
                        <option value="received">Received</option>
                        <option value="sent">Sent</option>
                      </select>
                    )}
                  </div>
                </div>
                <p className="order-note">
                  <span>Note - </span>
                  Once final invoice is generated, click on invoice button and
                  pay final amount to complete your order. After that your
                  product will be dispatched shortly.
                </p>
                {getFilteredData().length > 0 ? (
                  <div className="row g-3">
                    {getFilteredData().map((item, index) => {
                      return (
                        <div className="col-lg-6 col-md-6 px-2" key={index}>
                          <div className="order-product">
                            <div className="row align-items-center">
                              <div className="col-3">
                                <div className="order-image">
                                  <img
                                    src={item.commodity_product.thumbnail}
                                    onError={imageOnError}
                                    alt="product"
                                  />
                                </div>
                              </div>
                              <div className="col-7 ps-0">
                                <div className="order-detail">
                                  <h6 className="one-line-clamp">
                                    <span className="me-2">Quotation No:</span>{" "}
                                    {item.unique_id}
                                  </h6>
                                  <h6 className="one-line-clamp">
                                    {item.commodity_product.name}
                                  </h6>
                                  <div className="order-tag">
                                    <div>
                                      <span className="f-500">Brand:</span>
                                      <span>{item.brand.name}</span>
                                    </div>
                                    <div>
                                      <span className="f-500">Location:</span>
                                      <span>Ex-{item.origin_city}</span>
                                    </div>
                                    <div>
                                      <span className="f-500">Booked On:</span>
                                      <span>{item.updated_at}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <h6
                                className={`status ${
                                  item.status === "pending"
                                    ? "pending"
                                    : item.status === "cancel"
                                    ? "cancelled"
                                    : "delivered"
                                }`}
                              >
                                {item.status}
                              </h6>
                            </div>
                            <div className="row order-product-btn">
                              <div className="col-6 d-flex justify-content-center px-2">
                                {(item.type === "sent" || hasPermission('order', 'view')) ? (
                                  <Link
                                    to={
                                      item.type === "sent"
                                        ? `/order-ledger/${item.id}`
                                        : `/seller-order-ledger/${item.id}`
                                    }
                                    type="button"
                                    className="ord-btn ldgr"
                                    title="Order Invoice"
                                  >
                                    <i className="bi bi-eye me-1"></i>View Ledger
                                  </Link>
                                ) : (
                                  <button
                                    type="button"
                                    className="ord-btn ldgr disabled"
                                    title="No permission"
                                    disabled
                                  >
                                    <i className="bi bi-eye me-1"></i>View Ledger
                                  </button>
                                )}
                              </div>

                              <div className="col-6 d-flex justify-content-center px-2">
                                {(item.type === "sent" || hasPermission('order', 'view')) ? (
                                  <Link
                                    to={
                                      item.type === "sent"
                                        ? `/order-details/${item.id}`
                                        : `/seller-order-detail/${item.id}`
                                    }
                                    type="button"
                                    className="ord-btn invc"
                                    title="Order Detail"
                                  >
                                    <i className="bi bi-basket2 me-1"></i>Order
                                    Details
                                  </Link>
                                ) : (
                                  <button
                                    type="button"
                                    className="ord-btn invc disabled"
                                    title="No permission"
                                    disabled
                                  >
                                    <i className="bi bi-basket2 me-1"></i>Order
                                    Details
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <NoData />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
